module.exports = __webpack_public_path__ + "static/media/gastro-main-4.13f41362.jpg";